import React, { Component } from 'react';

class Achievements extends Component {

    render() {
        var achievements=null;
        if(this.props.data){
            achievements = this.props.data.map(function(achievement){
                return <div style={{marginBottom:'10px'}} key={achievement.title}><h3>{achievement.year}</h3>
                    <a className="info" href={achievement.url!==""?achievement.url:"#"}>{achievement.title}</a>
                    <p style={{color:'black'}}>{achievement.awarded_by}</p>
                </div>
            })

        }

        return (
            <section id="achievement">
                <div className="row achievement" style={{borderBottom: '1px solid #E8E8E8'}}>

                    <div className="three columns header-col">
                        <h1><span>Achievements</span></h1>
                    </div>

                    <div className="nine columns main-col">
                        {achievements}
                    </div>
                </div>
            </section>
        );
    }
}

export default Achievements;




// WEBPACK FOOTER //
// ./src/Components/Achievements.js